import Card from "@rio-cloud/rio-uikit/Card";

interface KPIData {
  balance: number;
  totalExpenses: number;
  totalRevenue: number;
  profitMargin: number;
  totalReceitas: number;
  totalDespesas: number;
  resultado: number;
  margemPercentual: number;
}

interface KPICardsProps {
  kpi?: KPIData | null;
}

const formatCurrency = (value?: number) =>
  (value ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

export default function KPICards({ kpi }: KPICardsProps) {
  const safeKpi = kpi ?? {
    balance: 0,
    totalExpenses: 0,
    totalRevenue: 0,
    profitMargin: 0,
    totalReceitas: 0,
    totalDespesas: 0,
    resultado: 0,
    margemPercentual: 0,
  };
  return (
    <div className="display-grid grid-cols-4 gap-20 margin-bottom-20">
      <Card className="display-flex flex-column padding-20 gap-5">
        <span className="text-size-16">Saldo</span>
        <span className="text-size-h2 text-medium">
          R${" "}
          {formatCurrency(safeKpi.resultado)}
        </span>
      </Card>

      <Card className="display-flex flex-row justify-content-between padding-20">
        <div className="display-flex flex-column gap-5">
          <span className="text-size-16">Despesa Total</span>
          <span className="text-size-h2 text-medium">
            R${" "}
            {formatCurrency(safeKpi.totalDespesas)}
          </span>
        </div>

        <div className="text-color-danger align-self-center">
          <span className="rioglyph rioglyph-arrow-down" style={{ fontSize: "50px" }} />
        </div>
      </Card>

      <Card className="display-flex flex-row justify-content-between padding-20">
        <div className="display-flex flex-column gap-5">
          <span className="text-size-16">Receita Total</span>
          <span className="text-size-h2 text-medium">
            R${" "}
            {formatCurrency(safeKpi.totalReceitas)}
          </span>
        </div>
        <div className="text-color-success align-self-center">
          <span className="rioglyph rioglyph-arrow-up" style={{ fontSize: "50px" }} />
        </div>
      </Card>

      <Card className="display-flex flex-column padding-20 gap-5">
        <span className="text-size-16">Margem de Lucro</span>
        <span className="text-size-h2 text-medium">{safeKpi.margemPercentual}%</span>
      </Card>
    </div>
  );
}
